module.exports = __webpack_public_path__ + "static/media/urbangoo02.267ed647.webp";